<template>
	<svg width="512" height="512" version="1.1" viewBox="0 0 135.46667 135.46666" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
		<g transform="translate(-29.301 -54.73)">
				<g transform="translate(146.01 178.11)" aria-label="ア ">
					<path d="m-113.88-117.13v21.773c7.3625-0.6266 12.532-1.0957 19.111-1.0957h81.615c-4.0729 7.6758-16.292 21.461-28.824 29.137l16.135 13.002c15.508-10.965 30.389-30.703 37.752-42.922 1.4098-2.3497 4.3862-6.11 6.1094-8.1465l-12.531-11.592c-2.8197 0.9399-11.436 1.4102-15.822 1.4102h-84.434c-6.5793 0-13.159-0.6265-19.111-1.5664zm45.271 32.896c0.78325 5.0128 1.0977 9.2415 1.0977 14.098 0 25.69-3.7598 42.297-23.654 56.082-5.796 4.2295-11.436 6.8921-16.449 8.6152l18.172 14.881c42.765-22.871 43.549-54.827 43.549-93.676z" fill="#ffffff" stroke-width=".81588" style="font-feature-settings:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-variant-numeric:normal"/>
				</g>
		</g>
	</svg>
</template>

<script>
  export default {
    name: 'logoSquare',
    props: ['light'],
  };
</script>



// WEBPACK FOOTER //
// src/components/LogoSquare.vue